<template>
  <div class="wrapper">
    <div class="elite-content_body_inner_header">
      <div class="elite-content_body_inner_header_left">
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5877 5.30114H13.0788L11.0524 1.25576C11.0132 1.16153 10.955 1.0764 10.8813 1.0057C10.8077 0.935006 10.7203 0.880252 10.6245 0.844865C10.5288 0.809477 10.4268 0.794216 10.3249 0.800036C10.223 0.805855 10.1234 0.83263 10.0323 0.878687C9.94119 0.924744 9.86057 0.989094 9.79548 1.06771C9.73038 1.14633 9.6822 1.23754 9.65394 1.33562C9.62568 1.4337 9.61796 1.53656 9.63125 1.63776C9.64455 1.73897 9.67857 1.83634 9.7312 1.9238L11.4162 5.30114H4.91385L6.5988 1.9238C6.67085 1.75078 6.67478 1.55691 6.60981 1.38112C6.54483 1.20532 6.41575 1.06061 6.2485 0.976042C6.08124 0.891474 5.88818 0.873308 5.70809 0.925191C5.52799 0.977074 5.37419 1.09517 5.27756 1.25576L3.25115 5.30114H0.742273C0.54541 5.30114 0.35661 5.37935 0.217407 5.51855C0.0782035 5.65775 0 5.84655 0 6.04341C0 6.24028 0.0782035 6.42908 0.217407 6.56828C0.35661 6.70748 0.54541 6.78569 0.742273 6.78569H0.801655L1.26186 12.2934C1.3402 13.2227 1.76554 14.0884 2.45324 14.7184C3.14095 15.3483 4.04062 15.6963 4.97323 15.693H11.3865C12.3191 15.6963 13.2187 15.3483 13.9064 14.7184C14.5942 14.0884 15.0195 13.2227 15.0978 12.2934L15.5283 6.78569H15.5877C15.7846 6.78569 15.9734 6.70748 16.1126 6.56828C16.2518 6.42908 16.33 6.24028 16.33 6.04341C16.33 5.84655 16.2518 5.65775 16.1126 5.51855C15.9734 5.37935 15.7846 5.30114 15.5877 5.30114ZM13.591 12.1672C13.5444 12.725 13.2893 13.2448 12.8767 13.6231C12.464 14.0014 11.924 14.2104 11.3642 14.2084H4.95838C4.39858 14.2104 3.85858 14.0014 3.44592 13.6231C3.03326 13.2448 2.77821 12.725 2.73156 12.1672L2.29362 6.78569H14.0364L13.591 12.1672ZM10.3918 10.4971C10.3918 10.6939 10.3136 10.8827 10.1744 11.0219C10.0352 11.1611 9.84641 11.2393 9.64955 11.2393H8.90727V11.9816C8.90727 12.1785 8.82907 12.3673 8.68987 12.5065C8.55066 12.6457 8.36186 12.7239 8.165 12.7239C7.96814 12.7239 7.77934 12.6457 7.64013 12.5065C7.50093 12.3673 7.42273 12.1785 7.42273 11.9816V11.2393H6.68045C6.48359 11.2393 6.29479 11.1611 6.15559 11.0219C6.01639 10.8827 5.93818 10.6939 5.93818 10.4971C5.93818 10.3002 6.01639 10.1114 6.15559 9.97218C6.29479 9.83298 6.48359 9.75478 6.68045 9.75478H7.42273V9.0125C7.42273 8.81564 7.50093 8.62684 7.64013 8.48764C7.77934 8.34844 7.96814 8.27023 8.165 8.27023C8.36186 8.27023 8.55066 8.34844 8.68987 8.48764C8.82907 8.62684 8.90727 8.81564 8.90727 9.0125V9.75478H9.64955C9.84641 9.75478 10.0352 9.83298 10.1744 9.97218C10.3136 10.1114 10.3918 10.3002 10.3918 10.4971Z"
            fill="#000"
          />
        </svg>

        <h2>{{ $t("APPS.PURCHASES_MODULE") }}</h2>
      </div>
    </div>
    <div class="elite-content_body_inner_container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moduleLayoutMixin from "@/mixins/module-layout-mixin";

export default {
  components: {},

  mixins: [moduleLayoutMixin],

  data() {
    return {};
  },

  methods: {},

  async mounted() {},

  computed: {},

  watch: {},
};
</script>
